<template>
  <div class="project wid100">
    <div class="list_item">

      <div class="item" >
        <img src="https://cyvideo.i-oranges.com/home/16.png" alt="work" style="width: 130px; margin:20px 0 60px 0;">
        <div class="item1 Center">

          <div class="titleBox Center" style="white-space: nowrap">
            <span class="title">服务</span>
            <span class="line">|</span>
          </div>
          <div class="list">
            <div class="itemsOneNode" v-for="(i,index) in itemsOne">
               <span :key="index" :class="{ active: currentId === i.id }" @click="handleClick(i.id)">
              {{ i.typeName }}</span>
            </div>
          </div>

        </div>
        <div class="item1 Start" style="margin: 50px 0 20px 0;">
            <div class="titleBox Center" style="white-space: nowrap">
              <span class="title">行业</span>
              <span class="line">|</span>
            </div>

            <div class="list" >
              <div class="itemsOneNode" v-for="(i,index) in itemsTwo">
               <span :key="index" :class="{ active: currentId === i.id }" @click="handleClick(i.id)">
              {{ i.typeName }}</span>
              </div>
            </div>

        </div>
<!--        <div :class="'item_c item_' + i">-->
<!--            <span-->
<!--              v-for="(i, index) in item"-->
<!--              :key="index"-->
<!--              class="a"-->
<!--              @click="handleClick(i.id)"-->
<!--              :class="{ active: currentId === i.id }"-->
<!--            >-->
<!--              <span class="b">#{{ i.typeName }}</span>-->
<!--            </span>-->
<!--        </div>-->
      </div>
    </div>

<!--    <div class="list" v-for="d in HomeList" :key="d.id">-->
<!--      <img :src="d.workUrl" class="wid100" @click="workTypes(d.workType, d.id, d.link)" :alt="d.content">-->
<!--    </div>-->
    <div class="list">
      <div class="swiper-container mySwiper " ref="Node"  v-for="Home in HomeList" :key="Home.id">
        <div class="swiper-wrapper">
          <div class="swiper-slide"  v-for="d in Home.workMap" :key="d.id" >
            <video controls="controls" muted v-if="d.type =='m4v' || d.type =='mp4'" class="wid100" :src="d.url" ></video>
            <img v-if="d.type =='jpg' || d.type =='png'|| d.type =='gif'" :src="d.url" class="wid100" :alt="Home.content">
            <p v-if="Home.workType!=2"><img src="https://cyvideo.i-oranges.com/home/19.png" alt="more"  @click="workTypes(Home.workType, Home.id, Home.link)"></p>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <div class="swiper-button-prev add_button-prev add_button-prev-bg1"></div>
        <div class="swiper-button-next add_button-next add_button-prev-bg1"></div>
      </div>
    </div>

  </div>
</template>

<script>
import {officialType, queryTypeList} from "../api/article";
import Swiper from "swiper";

export default {
  name: "ProjectComponent",
  data() {
    return {
      HomeList: [],
      items: [{ typeName: "全部", id: 0 }],  // 初始加上“全部”
      activeIndex: 0,
      page:1,
      pageSize:10,
      itemsList:[],
      currentId: 1,
      itemsOne:[],
      itemsTwo:[],
      defaultType:1 //默认查询整合营销
    }
  },
  methods: {
    handleClick(id) {
      this.currentId = id;
      // 这里可以调用 getList 方法
      this.getList(id);
    },
    workTypes(type, id, url) {
      if (type < 1 && url) {
        window.open(url)
      } else if (type ===1) {
        this.$router.push({ path: '/article/', query: { id: `${id}` } })
      }else {
        // console.log("不跳转");
      }
    },
    getList(id) {
      let that =this;
      this.activeIndex = id
         let d ={
           page:this.page,
           pageSize:this.pageSize,
           type:this.activeIndex|| this.defaultType,
         }
        officialType(d).then(res => {
          this.HomeList =res.data.records;

          setTimeout(function (){
            that.initSwiper();
          },1000)
        })
    },
    initSwiper() {
      let thatVideo='';
      this.mySwiper = new Swiper('.mySwiper', {
        loop: false, // 循环模式
        pagination: {
          el: '.swiper-pagination', // 分页器
          clickable: true,
        },
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on:{
          slideChangeTransitionEnd: function(){

            let element = this.slides[this.activeIndex].children[0];
            if (element.tagName === 'VIDEO') {
              element.play()
              thatVideo = element;
            }else{
              thatVideo.pause()
            }
          }
        },
        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },
  },
  mounted() {
    // officialHome().then(res => {
    //   this.HomeList = res.data;
    // })
    this.getList(0);

    queryTypeList().then(res => {
      this.itemsOne =res.data.serviceList
      this.itemsTwo =  res.data.industryList
    })


  }
}
</script>

<style scoped>
.project {
  background: #141414;
}
.project img {
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
}
.list{width: 100%; margin: 0 auto;}
.list_item {
  width: 100%;
  background: #000;
  padding: 20px 0;
}
.list_item .item {
  width: 76%;
  margin: 0 auto;
}
.list_item .item span{

}
.list_item .item1 {
  color: #fff;
  font-size: 18px;
  /*white-space: nowrap;*/
  font-family: Sans;
}
.itemsOneNode{display: inline-block;   margin-right: 10px;}
.itemsOneNode span{ padding: 0 6px; display: inline-block; margin: 0 5px;transition: all .2s; letter-spacing: 2px; cursor: pointer}
.list_item .item1 .title{ font-size: 22px;  margin-right: 0;letter-spacing: 2px;}
.list_item .item1 .line{ color: #ff6600;  margin: 0 10px;}
.list_item .item .list,.list_item .item .titleBox{min-height: 34px; line-height: 50px;}

.item_c{ margin: 0 auto;white-space: nowrap}
.item_1{ margin-left: 10%; text-align: right}
.item_3{margin: 0 auto;display: flex;flex-wrap: nowrap;justify-content: space-around;}
.list_item .active{color:#ff6600 !important;transform:scale(1.2) translateY(-5px); }
.list_item .a {
  margin:1% 4%;
  font-size: 22px;
  letter-spacing: 2px;
  color: #141414;
  padding: 1% 2%;
  cursor: pointer;
  display: inline-block;
  font-family: ali_R;


}
.itemsOneNode span:hover {
  color: #ff6600;
  transform:scale(1.2);
  transition: all .2s;
  /*display: block;*/
}

.item_0 >span{
    animation: shake 4s linear infinite;
}
.item_1>span{
    animation: shake 4.5s linear infinite;
}
.item_2>span{
    animation: shake 3.5s linear infinite;
}
.item_3>span{
    animation: shake 5s linear infinite;
}

@-webkit-keyframes shake {
    0%,100%{opacity: 0.8; transform: scale(1)}
   50%{opacity:1;transform: scale(1.2) }
}

.mySwiper{margin: 3% 0 5% 5% ; width:90%;}
.swiper-slide{text-align: center; padding-bottom: 30px;}
.swiper-wrapper .swiper-slide img,.swiper-wrapper .swiper-slide video{width: 84.5%; margin: 0 auto;}
.swiper-slide{text-align: center; position: relative; padding-bottom: 30px;}
.mySwiper:hover p{opacity: 1}
.swiper-slide p{width: 84.5%; height: 25px; transition: all .5s; position: absolute; bottom: 6px; left: 7.75%; text-align: right; opacity: 0;}
.swiper-slide p img{width: 6% !important;
  height: 25px !important;}
</style>
<style>
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
  opacity: 0 !important;
  transition: all 0.5s;
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectComponent.vue